export default "__VITE_ASSET__BADyG52E__"